import { useContext as n } from "react";
import { styled as t } from "./styled2.mjs";
import { DialogTitle as a, DialogContent as r, DialogActions as p } from "@mui/material";
import { DialogContext as g } from "./context.mjs";
const c = t(a)(({ theme: o }) => ({
  ...o.typography.h5,
  padding: `0 ${o.spacing(3)}`,
  paddingRight: o.spacing(9)
})), D = t(r)(({ theme: o }) => ({
  ...o.typography.body1,
  padding: `0 ${o.spacing(3)}`,
  color: o.palette.text.secondary,
  width: "100%"
})), f = t(p)(({ theme: o }) => {
  const { isDrawerLike: i } = n(g);
  return {
    width: "100%",
    padding: o.spacing(3),
    paddingBottom: 0,
    borderTop: `1px solid ${o.palette.other.divider}`,
    "> button:not(:first-of-type)": {
      marginLeft: o.spacing(2)
    },
    ...i ? {
      flexDirection: "row",
      [o.breakpoints.down("sm")]: {
        flexDirection: "column-reverse",
        "> button": {
          width: "100%"
        }
      },
      "> button:not(:first-of-type)": {
        marginLeft: 0
      },
      gap: o.spacing(1)
    } : {}
  };
});
export {
  f as DialogActions,
  D as DialogContent,
  c as DialogTitle
};
//# sourceMappingURL=styles79.mjs.map
